module.exports = __webpack_public_path__ + "img/knn-tfidf.b255920a.png";